import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Loader2, ShieldCheck, ShieldAlert } from "lucide-react";

export function AuditTab() {
  const [rows, setRows] = useState(null);
  const [check, setCheck] = useState(null);
  useEffect(() => {
    api.get("/governance/audit").then((r) => setRows(r.data));
    api.get("/governance/audit/verify").then((r) => setCheck(r.data));
  }, []);
  if (!rows) return <Loader2 className="mx-auto mt-10 h-6 w-6 animate-spin text-accent" />;

  return (
    <div className="space-y-4" data-testid="audit-tab">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-lg font-bold text-slate-900">Audit Log</h2>
          <p className="text-sm text-slate-500">Append-only, hash-chained record of governance and user-management actions.</p>
        </div>
        {check && (
          <div className={`flex items-center gap-1.5 text-sm font-bold ${check.valid ? "text-emerald-700" : "text-red-700"}`} data-testid="audit-integrity">
            {check.valid ? <ShieldCheck className="h-4 w-4" /> : <ShieldAlert className="h-4 w-4" />}
            {check.valid ? `Chain intact (${check.checked} entries)` : `Chain broken at #${check.broken_at_seq}`}
          </div>
        )}
      </div>
      <Card className="divide-y divide-slate-100 border-slate-200 shadow-sm">
        {rows.map((e) => (
          <div key={e.id} className="flex flex-col gap-1 p-3 text-sm sm:flex-row sm:items-center sm:justify-between" data-testid={`audit-row-${e.seq}`}>
            <div className="min-w-0">
              <span className="font-mono text-xs text-slate-400">#{e.seq}</span>{" "}
              <span className="font-semibold text-slate-800">{e.action}</span>{" "}
              <span className="text-slate-600">{e.detail}</span>
            </div>
            <div className="shrink-0 text-xs text-slate-500">{e.actor?.email} · {new Date(e.ts).toLocaleString()}</div>
          </div>
        ))}
      </Card>
    </div>
  );
}
